'use client';

import * as Sentry from '@sentry/nextjs';
import NextError from 'next/error';
import { useEffect } from 'react';
import { redirectToLogin } from '../redirectToLogin';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error);
    redirectToLogin();
  }, [error]);

  const renderError = () => {
    if (process.env.NODE_ENV === 'production') {
      return;
    }
    return <NextError statusCode={0} />;
  };

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        {renderError()}
      </body>
    </html>
  );
}